import React from "react";
import "./Group.css";
import {renderActions} from "components/BondTree/Devices/Device";
import Row from "react-bootstrap/Row";
import Card from 'react-bootstrap/Card';
import iconMS from "components/CustomApplications/TestApp/assets/img/devices/MS.png";



function Group({bond, groupId, groupData}) {
    return (<Row className="deviceRow">
        <Card className={"deviceCard"}>
            <Card.Body>
                <Card.Title>
                    <img className={'deviceTypeIcon'} src={iconMS}
                         alt={groupData.name}/>
                    {groupData.name}
                </Card.Title>
                <Card.Body className={'testAppDevice'}>
                    {renderActions(groupData.actions, bond, `/groups/${groupId}/`, "testAppDeviceActions")}
                </Card.Body>
            </Card.Body>
        </Card>
    </Row>);
}

export default Group;
